import React from 'react';

const AdditionalInfoForm = (props) => {
  const { 
    additionalInfo, 
    setAdditionalInfo, 
    handleSubmitAdditionalInfo, 
    inputStyle, 
    signInButtonStyle, 
    isLoading,
    errorMessage
  } = props;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdditionalInfo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSubmitAdditionalInfo();
  };

  const errorBoxStyle = {
    padding: '1rem',
    backgroundColor: '#f8d7da',
    color: '#721c24',
    borderRadius: '4px',
    marginBottom: '1rem',
    textAlign: 'left'
  };

  return (
    <div style={{ marginTop: '1rem' }}>
      <h3 style={{ color: '#ffffff !important', marginBottom: '1.5rem', fontSize: '28px', fontWeight: '600' }}>Complete Your Profile</h3>
      {errorMessage && (
        <div style={errorBoxStyle}>
          <p>{errorMessage}</p>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <select
          name="userType"
          value={additionalInfo.userType}
          onChange={handleChange}
          className={inputStyle}
          required
        >
          <option value="I am a..." disabled>I am a...</option>
          <option value="student">Student</option>
          <option value="parent">Parent</option>
          <option value="tutor">Tutor</option>
        </select>

        <input
          type="text"
          name="firstName"
          placeholder="First Name *"
          value={additionalInfo.firstName}
          onChange={handleChange}
          className={inputStyle}
          required
        />

        <input
          type="text"
          name="lastName"
          placeholder="Last Name *"
          value={additionalInfo.lastName}
          onChange={handleChange}
          className={inputStyle}
          required
        />

        <input
          type="tel"
          name="phone"
          placeholder="Phone Number *"
          value={additionalInfo.phone}
          onChange={handleChange}
          className={inputStyle}
          required
        />

        {(additionalInfo.userType === 'student' || additionalInfo.userType === 'parent') && (
          <input
            type="text"
            name="grade"
            placeholder="Grade/Year *"
            value={additionalInfo.grade}
            onChange={handleChange}
            className={inputStyle}
            required
          />
        )}

        <button
          type="submit"
          className={signInButtonStyle}
          disabled={isLoading}
        >
          {isLoading 
            ? 'Saving...' 
            : additionalInfo.userType === 'tutor' 
              ? 'Next: Select Subjects' 
              : 'Complete Profile'}
        </button>
      </form>
    </div>
  );
};

export default AdditionalInfoForm;
